import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { showModal } from 'react-redux-modal-provider';
import UserNotifyEmailService from '@app/services/userNotifyEmail.service';
import UserNotifyService from '@app/services/userNotify.service';
import ModalNotifyEmail from '@app/modals/notifications/ModalNotifyEmail';
import ModalNotifyPerson from '@app/modals/notifications/ModalNotifyPerson';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCommentDots,
    faComments,
    faTicketAlt,
    faPen,
    faHistory,
    faChevronUp,
    faCheckCircle,
    faTimesCircle,
    faEnvelope,
    faUsers,
    faUserCheck,
} from '@fortawesome/free-solid-svg-icons';

const BRAND = '#345380';

const TIPOS_EMAIL = [
    {
        key: 'Comentario-Interno',
        label: 'Comentario Interno',
        icon: faCommentDots,
        color: BRAND,
        bg: '#edf1f8',
        border: '#c5d0e6',
        desc: 'Notifica cuando se agrega un comentario interno a un ticket.',
    },
    {
        key: 'Comentario-Publico',
        label: 'Comentario Público',
        icon: faComments,
        color: '#17a2b8',
        bg: '#e8f7fa',
        border: '#abdde6',
        desc: 'Notifica cuando se agrega un comentario público a un ticket.',
    },
    {
        key: 'Asignacion-Ticket',
        label: 'Asignación de Ticket',
        icon: faTicketAlt,
        color: '#e08600',
        bg: '#fef8ec',
        border: '#f5d78e',
        desc: 'Notifica cuando se asigna un ticket a un usuario.',
    },
];

const TIPOS_SISTEMA = [
    {
        key: 'Comentarios',
        label: 'Recibir Comentarios',
        icon: faUsers,
        color: '#20c997',
        bg: '#e6faf5',
        border: '#a3e9d8',
        desc: 'Usuarios que reciben notificaciones de comentarios en tickets.',
    },
    {
        key: 'Tickets',
        label: 'Recibir Tickets',
        icon: faUserCheck,
        color: '#6610f2',
        bg: '#f0e9ff',
        border: '#c8adff',
        desc: 'Usuarios que reciben notificaciones al asignar tickets.',
    },
];

const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    return d.toLocaleDateString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

/* â”€â”€â”€ Historial: notificaciones por EMAIL â”€â”€â”€ */
const HistorialEmail = ({ historial }) => {
    if (!historial.length) {
        return (
            <div style={{ padding: '12px 16px', textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
                Sin historial registrado.
            </div>
        );
    }
    return (
        <div style={{ maxHeight: 260, overflowY: 'auto' }}>
            {historial.map((rec, idx) => (
                <div
                    key={rec.id_uxne}
                    style={{
                        padding: '10px 14px',
                        borderBottom: idx < historial.length - 1 ? '1px solid #f3f4f6' : 'none',
                        backgroundColor: rec.emailBool_uxne ? '#f0fdf4' : '#fafafa',
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                        <span style={{ fontSize: 11, color: '#6c757d' }}>
                            {formatDate(rec.createdAt)}
                            {rec.creadoPorEmail?.nombre_p && (
                                <>
                                    {' • '}
                                    <strong>{rec.creadoPorEmail.nombre_p}</strong>
                                </>
                            )}
                        </span>
                        <span
                            style={{
                                fontSize: 10,
                                fontWeight: 600,
                                padding: '2px 8px',
                                borderRadius: 4,
                                backgroundColor: rec.emailBool_uxne ? '#d4edda' : '#e9ecef',
                                color: rec.emailBool_uxne ? '#155724' : '#6c757d',
                            }}
                        >
                            <FontAwesomeIcon icon={rec.emailBool_uxne ? faCheckCircle : faTimesCircle} style={{ marginRight: 3 }} />
                            {rec.emailBool_uxne ? 'Activo' : 'Inactivo'}
                        </span>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        {(rec.emailStr_uxne ?? []).length > 0
                            ? rec.emailStr_uxne.map((email) => (
                                <span
                                    key={email}
                                    style={{
                                        fontSize: 11,
                                        padding: '2px 8px',
                                        borderRadius: 4,
                                        backgroundColor: '#e9ecef',
                                        color: '#495057',
                                    }}
                                >
                                    {email}
                                </span>
                              ))
                            : <span style={{ fontSize: 11, color: '#adb5bd' }}>Sin correos</span>
                        }
                    </div>
                </div>
            ))}
        </div>
    );
};

/* â”€â”€â”€ Historial: notificaciones del SISTEMA â”€â”€â”€ */
const HistorialSistema = ({ batches }) => {
    if (!batches.length) {
        return (
            <div style={{ padding: '12px 16px', textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
                Sin historial registrado.
            </div>
        );
    }
    return (
        <div style={{ maxHeight: 260, overflowY: 'auto' }}>
            {batches.map((batch, idx) => (
                <div
                    key={batch.batchId}
                    style={{
                        padding: '10px 14px',
                        borderBottom: idx < batches.length - 1 ? '1px solid #f3f4f6' : 'none',
                        backgroundColor: batch.isActive ? '#f0fdf4' : '#fafafa',
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                        <span style={{ fontSize: 11, color: '#6c757d' }}>
                            {formatDate(batch.createdAt)}
                            {batch.creadoPor?.nombre_p && (
                                <>
                                    {' • '}
                                    <strong>{batch.creadoPor.nombre_p}</strong>
                                </>
                            )}
                        </span>
                        <span
                            style={{
                                fontSize: 10,
                                fontWeight: 600,
                                padding: '2px 8px',
                                borderRadius: 4,
                                backgroundColor: batch.isActive ? '#d4edda' : '#e9ecef',
                                color: batch.isActive ? '#155724' : '#6c757d',
                            }}
                        >
                            <FontAwesomeIcon icon={batch.isActive ? faCheckCircle : faTimesCircle} style={{ marginRight: 3 }} />
                            {batch.isActive ? 'Activo' : 'Inactivo'}
                        </span>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        {batch.personas.length > 0
                            ? batch.personas.map((p) => (
                                <span
                                    key={p.id_uxn}
                                    style={{
                                        fontSize: 11,
                                        padding: '2px 8px',
                                        borderRadius: 4,
                                        backgroundColor: '#e9ecef',
                                        color: '#495057',
                                    }}
                                >
                                    {p.userName?.nombre_p ?? `ID ${p.personId_uxn}`}
                                </span>
                              ))
                            : <span style={{ fontSize: 11, color: '#adb5bd' }}>Sin usuarios</span>
                        }
                    </div>
                </div>
            ))}
        </div>
    );
};


/* â”€â”€â”€ Shared styles â”€â”€â”€ */
const cardWrap = (border) => ({
    borderRadius: 6,
    border: `1px solid ${border}`,
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
});
const iconBox = (color) => ({
    width: 40, height: 40, borderRadius: 6, backgroundColor: color,
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
});
const cardTitle = { fontWeight: 700, fontSize: 14, color: '#212529', lineHeight: 1.3 };
const cardDesc  = { fontSize: 11, color: '#6c757d', marginTop: 2 };
const bodyRow   = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 };
const bodyLabel = { fontSize: 11, fontWeight: 600, color: '#495057', textTransform: 'uppercase', letterSpacing: '0.04em' };
const statusBadge = (ok) => ({
    fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 4,
    backgroundColor: ok ? '#d4edda' : '#f8d7da',
    color: ok ? '#155724' : '#721c24',
    border: ok ? '1px solid #c3e6cb' : '1px solid #f5c6cb',
});
const chipBox  = {
    minHeight: 44, backgroundColor: '#f8f9fa', borderRadius: 4,
    border: '1px solid #dee2e6', padding: '8px 10px',
    display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: 'center',
};
const chip     = { fontSize: 12, padding: '3px 10px', borderRadius: 4, backgroundColor: '#e9ecef', color: '#495057', border: '1px solid #ced4da', fontWeight: 500 };
const emptyText = { fontSize: 12, color: '#adb5bd', fontStyle: 'italic' };
const footerRow = { padding: '10px 18px', borderTop: '1px solid #dee2e6', display: 'flex', gap: 8, backgroundColor: '#f8f9fa' };
const btnPrimary = {
    flex: 1, padding: '7px 0', borderRadius: 4, border: 'none',
    backgroundColor: BRAND, color: '#fff', fontWeight: 600, fontSize: 13,
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
};
const btnSecondary = {
    padding: '7px 14px', borderRadius: 4, border: '1px solid #ced4da',
    backgroundColor: '#fff', color: '#495057', fontWeight: 600, fontSize: 13,
    cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5,
};
const badge = { backgroundColor: BRAND, color: '#fff', borderRadius: 4, fontSize: 10, padding: '1px 6px', fontWeight: 700 };
const historialHeader = {
    padding: '7px 16px', backgroundColor: '#edf1f8', fontSize: 12, fontWeight: 600,
    color: BRAND, display: 'flex', alignItems: 'center', gap: 6, borderBottom: '1px solid #c5d0e6',
};

/* â”€â”€â”€ Card: EMAIL â”€â”€â”€ */
const EmailCard = ({ tipo, items, onEditar }) => {
    const { key, label, icon, color, bg, border, desc } = tipo;
    const [showHistorial, setShowHistorial] = useState(false);

    const historial = (items ?? [])
        .filter((i) => i.tipo_uxne === key)
        .sort((a, b) => b.id_uxne - a.id_uxne);

    const activo = historial.find((i) => Boolean(i.emailBool_uxne));
    const emailsActivos = activo?.emailStr_uxne ?? [];

    return (
        <div className="col-md-12 col-lg-4 mb-4">
            <div style={cardWrap(border)}>
                <div style={{ backgroundColor: bg, padding: '16px 18px', borderBottom: `1px solid ${border}` }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={iconBox(color)}>
                            <FontAwesomeIcon icon={icon} style={{ color: '#fff', fontSize: 17 }} />
                        </div>
                        <div>
                            <div style={cardTitle}>{label}</div>
                            <div style={cardDesc}>{desc}</div>
                        </div>
                    </div>
                </div>

                <div style={{ padding: '14px 18px', flex: 1 }}>
                    <div style={bodyRow}>
                        <span style={bodyLabel}>
                            <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: 5, color: '#adb5bd' }} />
                            Correos activos
                        </span>
                        <span style={statusBadge(Boolean(activo))}>
                            <FontAwesomeIcon icon={activo ? faCheckCircle : faTimesCircle} style={{ marginRight: 3 }} />
                            {activo ? 'Configurado' : 'Sin configurar'}
                        </span>
                    </div>
                    <div style={chipBox}>
                        {emailsActivos.length > 0
                            ? emailsActivos.map((email) => (
                                <span key={email} style={chip}>
                                    {email}
                                </span>
                              ))
                            : <span style={emptyText}>Sin correos configurados</span>
                        }
                    </div>
                </div>

                <div style={footerRow}>
                    <button type="button" onClick={() => onEditar(key)} style={btnPrimary}>
                        <FontAwesomeIcon icon={faPen} />
                        {' '}
                        Editar correos
                    </button>
                    <button type="button" onClick={() => setShowHistorial((v) => !v)} title="Ver historial" style={btnSecondary}>
                        <FontAwesomeIcon icon={showHistorial ? faChevronUp : faHistory} />
                        {historial.length > 0 && <span style={badge}>{historial.length}</span>}
                    </button>
                </div>

                {showHistorial && (
                    <div style={{ borderTop: '1px solid #dee2e6' }}>
                        <div style={historialHeader}>
                            <FontAwesomeIcon icon={faHistory} />
                            {' '}
                            Historial de configuraciones
                            <FontAwesomeIcon
                                icon={faChevronUp}
                                style={{ marginLeft: 'auto', cursor: 'pointer', color: '#6c757d' }}
                                onClick={() => setShowHistorial(false)}
                            />
                        </div>
                        <HistorialEmail historial={historial} />
                    </div>
                )}
            </div>
        </div>
    );
};

/* â”€â”€â”€ Card: SISTEMA â”€â”€â”€ */
const SistemaCard = ({ tipo, sysItems, onEditar }) => {
    const { key, label, icon, color, bg, border, desc } = tipo;
    const [showHistorial, setShowHistorial] = useState(false);

    const registros = (sysItems ?? []).filter((r) => r.tipo_uxn === key);

    const batches = Object.values(
        registros.reduce((acc, rec) => {
            const bid = rec.batchId_uxn ?? 0;
            if (!acc[bid]) {
                acc[bid] = {
                    batchId: bid,
                    isActive: Boolean(rec.isActive_uxn),
                    createdAt: rec.createdAt,
                    creadoPor: rec.creadoPor,
                    personas: [],
                };
            }
            acc[bid].personas.push(rec);
            return acc;
        }, {})
    ).sort((a, b) => b.batchId - a.batchId);

    const activoBatch = batches.find((b) => b.isActive);
    const personasActivas = activoBatch?.personas ?? [];

    return (
        <div className="col-md-12 col-lg-6 mb-4">
            <div style={cardWrap(border)}>
                <div style={{ backgroundColor: bg, padding: '16px 18px', borderBottom: `1px solid ${border}` }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={iconBox(color)}>
                            <FontAwesomeIcon icon={icon} style={{ color: '#fff', fontSize: 17 }} />
                        </div>
                        <div>
                            <div style={cardTitle}>{label}</div>
                            <div style={cardDesc}>{desc}</div>
                        </div>
                    </div>
                </div>

                <div style={{ padding: '14px 18px', flex: 1 }}>
                    <div style={bodyRow}>
                        <span style={bodyLabel}>
                            <FontAwesomeIcon icon={faUsers} style={{ marginRight: 5, color: '#adb5bd' }} />
                            Usuarios activos
                        </span>
                        <span style={statusBadge(personasActivas.length > 0)}>
                            <FontAwesomeIcon icon={personasActivas.length > 0 ? faCheckCircle : faTimesCircle} style={{ marginRight: 3 }} />
                            {personasActivas.length > 0 ? 'Configurado' : 'Sin configurar'}
                        </span>
                    </div>
                    <div style={chipBox}>
                        {personasActivas.length > 0
                            ? personasActivas.map((p) => (
                                <span key={p.id_uxn} style={chip}>
                                    {p.userName?.nombre_p ?? `ID ${p.personId_uxn}`}
                                </span>
                              ))
                            : <span style={emptyText}>Sin usuarios configurados</span>
                        }
                    </div>
                </div>

                <div style={footerRow}>
                    <button
                        type="button"
                        onClick={() => onEditar(key, personasActivas.map((p) => p.personId_uxn))}
                        style={btnPrimary}
                    >
                        <FontAwesomeIcon icon={faPen} />
                        {' '}
                        Editar usuarios
                    </button>
                    <button type="button" onClick={() => setShowHistorial((v) => !v)} title="Ver historial" style={btnSecondary}>
                        <FontAwesomeIcon icon={showHistorial ? faChevronUp : faHistory} />
                        {batches.length > 0 && <span style={badge}>{batches.length}</span>}
                    </button>
                </div>

                {showHistorial && (
                    <div style={{ borderTop: '1px solid #dee2e6' }}>
                        <div style={historialHeader}>
                            <FontAwesomeIcon icon={faHistory} />
                            {' '}
                            Historial de configuraciones
                            <FontAwesomeIcon
                                icon={faChevronUp}
                                style={{ marginLeft: 'auto', cursor: 'pointer', color: '#6c757d' }}
                                onClick={() => setShowHistorial(false)}
                            />
                        </div>
                        <HistorialSistema batches={batches} />
                    </div>
                )}
            </div>
        </div>
    );
};

/* â”€â”€â”€ Page â”€â”€â”€ */
const UserNotifyEmailPage = ({ user }) => {
    const [emailItems,  setEmailItems]  = useState([]);
    const [sysItems,    setSysItems]    = useState([]);
    const [loadingEmail, setLoadingEmail] = useState(false);
    const [loadingSys,   setLoadingSys]   = useState(false);
    const navigate = useNavigate();

    const actualizarEmail = async () => {
        setLoadingEmail(true);
        try {
            const response = await UserNotifyEmailService.getAll();
            const parsed = (Array.isArray(response) ? response : []).map((rec) => ({
                ...rec,
                emailStr_uxne: Array.isArray(rec.emailStr_uxne)
                    ? rec.emailStr_uxne
                    : (() => { try { return JSON.parse(rec.emailStr_uxne); } catch (_) { return []; } })(),
            }));
            setEmailItems(parsed);
        } catch (_) {
            setEmailItems([]);
        } finally {
            setLoadingEmail(false);
        }
    };

    const actualizarSys = async () => {
        setLoadingSys(true);
        try {
            const response = await UserNotifyService.getAllFull();
            setSysItems(Array.isArray(response) ? response : []);
        } catch (_) {
            setSysItems([]);
        } finally {
            setLoadingSys(false);
        }
    };

    const onEditarEmail = (tipo) => {
        const activo = emailItems.find((i) => i.tipo_uxne === tipo && Boolean(i.emailBool_uxne));
        showModal(ModalNotifyEmail, {
            tipo,
            emailsActivos: activo?.emailStr_uxne ?? [],
            onGuardar: actualizarEmail,
        });
    };

    const onEditarSys = (elemento, personalArr) => {
        showModal(ModalNotifyPerson, {
            elemento,
            personalArr,
            onGuardar: actualizarSys,
        });
    };

    useEffect(() => {
        if (user) {
            if (user.id_p < 9999) {
                actualizarEmail();
                actualizarSys();
            } else {
                navigate('/');
            }
        }
    }, [user]);

    const sectionHeader = (icon, title, subtitle) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
            <div style={{ width: 36, height: 36, borderRadius: 6, backgroundColor: BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FontAwesomeIcon icon={icon} style={{ color: '#fff', fontSize: 16 }} />
            </div>
            <div>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#212529' }}>{title}</div>
                <div style={{ fontSize: 11, color: '#6c757d' }}>{subtitle}</div>
            </div>
        </div>
    );

    return (
        <div className="container-fluid">
            <div style={{ padding: '20px 0 16px', borderBottom: '1px solid #dee2e6', marginBottom: 28 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 40, height: 40, borderRadius: 6, backgroundColor: BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <FontAwesomeIcon icon={faEnvelope} style={{ color: '#fff', fontSize: 18 }} />
                    </div>
                    <div>
                        <h4 style={{ margin: 0, fontWeight: 700, color: '#212529' }}>Notificaciones</h4>
                        <p style={{ margin: 0, fontSize: 12, color: '#6c757d' }}>
                            Configure correos y usuarios que reciben notificaciones por cada evento del sistema.
                        </p>
                    </div>
                </div>
            </div>

            {/* ── Sección EMAIL ── */}
            {sectionHeader(faEnvelope, 'Notificaciones por Correo', 'Correos electrónicos que reciben alertas automáticas.')}
            {loadingEmail
                ? <div style={{ textAlign: 'center', padding: 40, color: '#adb5bd', fontSize: 13 }}>Cargando...</div>
                : (
                    <div className="row">
                        {TIPOS_EMAIL.map((tipo) => (
                            <EmailCard key={tipo.key} tipo={tipo} items={emailItems} onEditar={onEditarEmail} />
                        ))}
                    </div>
                )
            }

            <div style={{ borderTop: '1px solid #dee2e6', margin: '8px 0 28px' }} />

            {/* â”€â”€ Sección SISTEMA â”€â”€ */}
            {sectionHeader(faUsers, 'Notificaciones del Sistema', 'Usuarios internos que reciben notificaciones en la plataforma.')}
            {loadingSys
                ? <div style={{ textAlign: 'center', padding: 40, color: '#adb5bd', fontSize: 13 }}>Cargando...</div>
                : (
                    <div className="row">
                        {TIPOS_SISTEMA.map((tipo) => (
                            <SistemaCard key={tipo.key} tipo={tipo} sysItems={sysItems} onEditar={onEditarSys} />
                        ))}
                    </div>
                )
            }
        </div>
    );
};

const mapStateToProps = (state) => ({ user: state.auth.currentUser });
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UserNotifyEmailPage);
